import TicketsList from './TicketsList'

const TIcketsListWrapper = () => {
  return (
    <>
      <TicketsList />
    </>
  )
}

export default TIcketsListWrapper
